import { styled } from 'goober';
import { WrapperStylesBySize } from './user-profile.mixins';
import { COLORS, hexToRGB } from '../../config/colors/colors';
import { Link } from '@vtbhome/juicyfront';

export const Wrapper = styled('div')`
    display: flex;
    align-items: center;
    background-color: ${COLORS.neutral_05};
    ${WrapperStylesBySize}
`;

export const AvatarWrapper = styled('div')<{ size: number }>`
    position: relative;
    width: ${({ size }) => size}px;
    height: ${({ size }) => size}px;

    & > * {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
`;

export const TooltipContent = styled('div')`
    display: flex;
    padding: 8px 6px;
    gap: 16px;
`;

export const UserInfo = styled('div')`
    display: flex;
    gap: 8px;
    flex-direction: column;
`;

export const UserJob = styled('div')`
    display: flex;
    gap: 4px;
    flex-direction: column;
`;

export const ContactLink = styled(Link)`
    display: flex;
    gap: 7px;
`;

export const UserIcon = styled('div')`
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: 0.5px solid ${hexToRGB(COLORS.black, 0.08)};
    color: ${COLORS.light_primary};
`;
